import { VStack } from '@chakra-ui/react';
import { SignatureBox } from '@common/components/SignatureBox';
import React from 'react';

type SignatureProps = {
  onSave: (dataUrl: string, blob: Blob) => void;
  onClear: () => void;
};

export const Signature: React.FC<SignatureProps> = ({ onClear, onSave }) => {
  return (
    <VStack gap="20px" alignItems={'flex-start'} justifyContent={'flex-start'} width="full">
      <SignatureBox onSave={onSave} onClear={onClear} />
    </VStack>
  );
};
